import { FormControl, ValidatorFn } from '@angular/forms';

export class ExtendedFormControl extends FormControl {
    public name: string;

    constructor(name: string, value: any, validations: ValidatorFn[], disabled: boolean = false) {
        super();
        this.name = name;
        if (disabled) {
            this.disable({ emitEvent: false });
        }
        this.setValue(value, { emitEvent: false });
        this.setValidators(validations);
    }
}
